import { useMemo, useState } from "react";
import { messages } from "../messages";

export function useMode() {
  const [mode, setMode] = useState<"edit" | "duplicate" | "add">("add");

  const title = useMemo(() => {
    switch (mode) {
      case "edit":
        return messages.edit;
      case "duplicate":
        return messages.duplicate;
      case "add":
      default:
        return messages.create;
    }
  }, [mode]);

  return useMemo(() => ({ mode, setMode, title }), [mode, title]);
}
